import lightning from 'images/bonuses/bonuses-card/lightning.png';
import cake from 'images/bonuses/bonuses-card/cake.png';
import gift from 'images/bonuses/bonuses-card/gift.png';
import coinHeader from 'images/bonuses/header/coin.png';
import lightningHeader from 'images/bonuses/header/lightning.png';
import cakeHeader from 'images/bonuses/header/cake.png';
import giftHeader from 'images/bonuses/header/gift.png';

export const PARTS_IN_PROGRESS = 5;

export const getImageByBonusesType = (type = '', birthday = false): string => {
    switch (type.toLowerCase()) {
    case 'classic':
        return gift;
    default:
        return birthday ? cake : lightning;
    }
};

export const getKeyByType = (type = '', birthday = false): string => {
    switch (type.toLowerCase()) {
    case 'classic':
        return 'classic';
    default:
        return birthday ? 'birthday_bonus' : 'instant_bonus';
    }
};

export const getImageHeaderByType = (type = '', birthday = false): string => {
    switch (type.toLowerCase()) {
    case 'advance':
        return birthday ? cakeHeader : lightningHeader;
    case 'classic':
        return giftHeader;
    default:
        return coinHeader;
    }
};
